export const noTasksToDoRightNow = "No tasks to do right now";
export const noTasksContractSuspended =
  "You will not be given new tasks while your contract is suspended.";
export const taskNotAssigned =
  "You have not been assigned to complete this task - no action is needed.";
export const taskWithdrew = "You withdrew from this action.";
export const taskCompleted = "You've completed this task.";
export const taskDeadlinePassed = "The deadline for member action has passed.";
export const taskDeadlinePassedDescription =
  "You do not need to complete this task, but you can still do so below if you would like.";

export const TASK_DISMISS_MESSAGE_CURRENTLY_AWAY =
  "You are currently away, so this task is optional for you. You can either complete it or dismiss it.";
// We might show this while the task is in progress or after the deadline
export const TASK_DISMISS_MESSAGE_WAS_AWAY =
  "You were away during this task, so it is optional for you. You can either complete it or dismiss it.";
export const TASK_DISMISS_MESSAGE_WILL_BE_AWAY =
  "You will be away before this task is due, so it is optional for you. You can either complete it or dismiss it.";
export const TASK_DISMISS_MESSAGE_AFTER_DEADLINE =
  "You have missed this task's deadline. You can either complete it or dismiss it.";

export const externalOnly =
  "This action is intended for external participants. Members cannot complete it.";

export const awayRangesDescription =
  "You can schedule a period of time when you won't be able to complete Alliance actions. This will let the office know not to expect you to complete tasks while you're away.";
